import { render, staticRenderFns } from "./DSButtons.vue?vue&type=template&id=6bf7f52d&"
import script from "./DSButtons.vue?vue&type=script&lang=js&"
export * from "./DSButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports